// extracted by mini-css-extract-plugin
module.exports = {"container":"CouponBanner_container__LyqHg","couponTitle":"CouponBanner_couponTitle__dxcUM","rtl":"CouponBanner_rtl__UpMUT"};